import { render } from "./ATIButtonComponent.vue?vue&type=template&id=b934c988"
import script from "./ATIButtonComponent.vue?vue&type=script&lang=js"
export * from "./ATIButtonComponent.vue?vue&type=script&lang=js"

import "./ATIButtonComponent.vue?vue&type=style&index=0&id=b934c988&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__